import React from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";

import { Button, Ripple, Img } from "arv-reactcomponents";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";
import { EmailInput, MobileNumberInput } from "../";
import staticEndpoints from "../../../api/endPoints/staticEndpoints";
import { blackboltConfig } from "../../../constants";

@inject("LoginStore")
@observer
class MissedFields extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoginWithPhone: false,
      authErrorMsg: "",
    };
    this.emailFields = null;
    this.mobileNoFields = null;
    this.isMobileMissing = false;
    this.isEmailMissing = false;
    this.onSubmit = this.onSubmit.bind(this);
    this.showLoginView = this.showLoginView.bind(this);
    this.onChange = this.onChange.bind(this);
    this.socialRegister = this.socialRegister.bind(this);
  }
  componentDidMount() {
    const invalidInput = document.querySelector(".nw-missed-form input");
    if (invalidInput) {
      setTimeout(() => {
        invalidInput.focus();
      });
    }
  }

  socialRegister(data) {
    this.props.LoginStore.userOnboard(data, true)
    .then(res => {
      console.log(res);
    })
    .catch(error => {
      const err = error && error.data && error.data.errors;
      if (err && err[0] && blackboltConfig.ERROR_CODE.includes(err[0].status)) {
        const { detail = defaultErrorMsg } = err[0];
        this.setState({
          authErrorMsg: detail,
        });
      } else {
        this.setState({
          authErrorMsg: blackboltConfig.ERROR_MSG,
        });
      }
      Analytics.trackEvent({
        action: Event.action.REGISTER_ERROR,
        category: Event.category.LOGIN,
        label: Event.label.getRegisterationError(err),
      });
    });
  }

  onSubmit(e) {
    e.preventDefault();
    const invalidInput = document.querySelector(
      ".nw-missed-form input.is-invalid",
    );
    if (invalidInput) {
      return invalidInput.focus();
    }
    let data = {};
    let mobileNo;
    let email;
    if (this.isMobileMissing && this.mobileNoFields.state.isMobileInputValid) {
      mobileNo = this.mobileNoFields.state.mobileNo;
      data = { ...data, mobileNo };
      this.socialRegister(data);
    } else if (this.isEmailMissing && this.emailFields.state.isEmailInputValid) {
      email = this.emailFields.state.email;
      data = { ...data, email };
      this.socialRegister(data);
    }
  }

  onChange() {
    const { showLoginWithPhone, authErrorMsg } = this.state;
    if (showLoginWithPhone || authErrorMsg) {
      this.setState({ showLoginWithPhone: false, authErrorMsg: "" });
    }
  }
  get isShowLoader() {
    return this.props.LoginStore.loader ? "" : "nwc-hidden";
  }
  showLoginView(e) {
    e.preventDefault();
    Analytics.trackEvent({
      action: Event.action.SOCIAL_LOGIN_PHONE_NUDGE,
      category: Event.category.LOGIN,
    });
    const { mobileNo } = this.mobileNoFields.state;
    this.props.LoginStore.changeView("login", mobileNo);
  }
  render() {
    const { missingFieldsLogin } = this.props.LoginStore;
    const { showLoginWithPhone, authErrorMsg } = this.state;
    if (
      missingFieldsLogin &&
      missingFieldsLogin.missingFields
    ) {
      this.isMobileMissing =
        this.props.LoginStore.missingFieldsLogin.missingFields.indexOf(
          "mobileNumber",
        ) > -1;
      this.isEmailMissing =
        this.props.LoginStore.missingFieldsLogin.missingFields.indexOf(
          "emailId",
        ) > -1;
    }
    return (
      <div className="nw-login-container">
        <div className="nw-login-heading">
          <h1 className="nw-login-title">YOU ARE ALMOST THERE!</h1>
        </div>
        <div className="nw-missingfield-img">
          <Img
            src={staticEndpoints.missedImage}
            alt="mobile image to show missing mobile num"
          />
        </div>
        <form className="nw-form nw-missed-form" onSubmit={this.onLogin}>
          {this.isEmailMissing ? (
            <EmailInput
              className="nw-login-input nw-missed-email"
              placeholder="Enter Your Email-ID"
              name="email"
              ref={values => {
                this.emailFields = values;
              }}
            />
          ) : (
              ""
            )}
          {this.isMobileMissing ? (
            <MobileNumberInput
              className="nw-login-input nw-missed-mobilenumber"
              placeholder="Mobile Number"
              name="mobile number"
              maxLength={10}
              onChange={this.onChange}
              ref={values => {
                this.mobileNoFields = values;
              }}
            />
          ) : (
              ""
            )}
          <Ripple className="nwc-ripple-light">
            <Button
              type="submit"
              className="nwc-btn-primary nw-login-btn nw-missed-submitbtn"
              onClick={this.onSubmit}
            >
              REGISTER
              <div className={`nw-login-loader ${this.isShowLoader}`}>
                <img
                  className="nw-loader"
                  src="//static.nnnow.com/client/assets/images/icon/loader.gif"
                  alt="loader"
                />
              </div>
            </Button>
          </Ripple>
          {authErrorMsg ? (
            <span className="nw-login-error">{authErrorMsg}</span>
          ) : (
              ""
            )}
          {showLoginWithPhone ? (
            <Button
              className="nwc-button nw-login-link"
              onClick={this.showLoginView}
            >
              Login with Phone
            </Button>
          ) : (
              ""
            )}
        </form>
      </div>
    );
  }
}

MissedFields.wrappedComponent.propTypes = {
  LoginStore: PropTypes.shape({
    userOnboard: PropTypes.func.isRequired,
    missingFieldsLogin: PropTypes.object.isRequired,
    changeView: PropTypes.func.isRequired,
    loader: PropTypes.bool.isRequired,
  }).isRequired,
};

export default MissedFields;



// WEBPACK FOOTER //
// ./src/component/Login/MissedFields/index.js